import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ContactsRepository } from './repositories/contacts.repository';
import { CONTACTS_REPOSITORY } from './repositories/IContact.repository';
import { ContactsService } from './services/contacts.service';
import { CONTACTS_SERVICE } from './services/IContact.service';
import { ContactsEffects } from './state/contact.effects';
import { contactsReducer } from './state/contact.reducer';
import { ContactsStore, ContactStore } from './state/contact.store';
import { ContactInteractionsStore } from './state/interactions.store';

interface ModuleOptionsInterface {
  providers: Provider[];
}

@NgModule({
  declarations: [],
  imports: [
    HttpClientModule,
    StoreModule.forFeature('contacts', contactsReducer),
    EffectsModule.forFeature([ContactsEffects]),
  ],
  exports: [],
})
export class ContactsCoreModule {
  static forRoot(
    config?: ModuleOptionsInterface
  ): ModuleWithProviders<ContactsCoreModule> {
    return {
      ngModule: ContactsCoreModule,
      providers: [
        { provide: CONTACTS_SERVICE, useClass: ContactsService },
        { provide: CONTACTS_REPOSITORY, useClass: ContactsRepository },
        ...(config?.providers || []),
        ContactStore,
        ContactsStore,
        ContactInteractionsStore,
      ],
    };
  }
}
